import {
  ReactivateUserPage,
} from 'src/views/reactivateUser'
import pathMap from 'src/paths/pathMap'

class ReactivateUserRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.REACTIVATE_USER,
        component: ReactivateUserPage
      }
    ]
  }
}

export default ReactivateUserRoute
